import axios from './index'

/**
 * Strażnik zamknięcia wizyty — cienki klient trzech tras EHR, które dalej
 * rozmawiają z medapi (tam mieszka reguła: werdykt, usługi, liczba guzków).
 */
export default {
  zalegle() {
    return axios.get('/api/auth/wizyty/zalegle')
  },
  uslugi(pwId) {
    return axios.get(`/api/auth/wizyty/${pwId}/uslugi`)
  },
  zamknij(pwId, dane) {
    return axios.post(`/api/auth/wizyty/${pwId}/zamknij`, dane)
  },
  /** lekarz zamknął okno krzyżykiem — strażnik nie blokuje do końca dnia (lista zaległych wraca jutro) */
  odloz() {
    return axios.post('/api/auth/wizyty/zalegle/odloz')
  }
}
